// extracted by mini-css-extract-plugin
export default {"FormItem":"_FormItem--ftvA8","FormLabel":"_FormLabel--tySyP"};